import * as React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Sticky } from "react-sticky";
import cx from "classnames";

import "./Nav.css";
import { Box } from "../../components";

const logo: string = require("../../images/logo.png");

export interface NavProps {
  fullWidth?: boolean;
  hasShadow?: boolean;
  collapsed: boolean;
  children: React.ReactChild[];
  toggleCollapse: () => void;
  assignRef: (el: HTMLButtonElement) => void;
}

const getNavBarCollapseClass = ({ collapsed }: NavProps) =>
  cx("navbar-collapse", "collapse", {
    in: !collapsed,
  });

const Nav = (props: NavProps) => (
  <Sticky disableCompensation topOffset={-10}>
    {({ style }) => (
      <nav className="navbar navbar-default navbar-custom" style={style}>
        <Box {...props}>
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              onClick={props.toggleCollapse}
              ref={props.assignRef}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <HashLink to="/#home" className="navbar-brand">
              <img className="img-responsive" src={logo} />
            </HashLink>
          </div>

          <div className={getNavBarCollapseClass(props)}>
            <ul className="nav navbar-nav navbar-nav-justified">
              {props.children}
              <li>
                <Link className="login-btn" to="/account/register">
                  Đăng ký
                </Link>
              </li>
            </ul>
          </div>
        </Box>
      </nav>
    )}
  </Sticky>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/layouts/Main/Nav.tsx